import React, { useEffect, useState } from "react";
import { IChartOption } from "src/shared/models/IDashboards.models";
import ReactECharts from 'echarts-for-react';
import { NoDataChart } from "./NoDataChart";

interface FormProps {
  details: IChartOption;
  titleChart: string;
  titleChartNoData: string;
  typeIcon?: boolean;
}

export const EchartDonut = React.memo(({ details, titleChart, titleChartNoData, typeIcon = false }: FormProps) => {
  const chartColors = ["#2196F3", "#B0E57C", "#79C4FF"]; //#FFA500
  const [option, setOption] = useState<any>(null);

  useEffect(() => {
    if(details?.labels?.length > 0)
      loadData()
  }, [details]);

  const loadData = () => {
    const dataInfo = 
      details?.labels?.map((y: any, index: number) => {
        return { value: details?.series[index] ?? 0, name: y };
      }) || {}
    setOption(
    {
      title : {
        avoidLabelOverlap: true,
        text: titleChart,
        subtext: "",//'subtitulo'
        x:'left',
        y: 20,
        textStyle: {
          fontSize: 16,
          fontFamily: 'Open Sans,sans-serif',
        },
      },
      color: chartColors,
      textStyle: {
        fontSize: 11,
        fontFamily: 'Open Sans,sans-serif',
      },
      tooltip : {
        trigger: 'item',
        formatter: "{a} <br/>{b} : {c} ({d}%)"
      },
      legend: {
        orient: 'vertical',
        left: 'left',
        bottom: 20, // Coloca la leyenda en la parte inferior
        data: details?.labels ?? [],
        avoidLabelOverlap: true,
        icon: 'circle' // Cambiar la forma de los íconos de la leyenda a círculos
      },
      series : [
        {
          name: titleChart,
          type: "pie",
          radius :  ['50%', '70%'] ,
          top: '20%', // Ajusta este valor para mover el gráfico hacia abajo
          avoidLabelOverlap: true,
          data: dataInfo,
          fontFamily: 'Open Sans,sans-serif',
          itemStyle: {
            fontFamily: 'Open Sans,sans-serif',
            emphasis: {
            shadowBlur: 10,
            shadowOffsetX: 0,
            shadowColor: 'rgba(0, 0, 0, 0.5)'
            }
          },
          textStyle: {
            fontFamily: 'Open Sans,sans-serif',
          },
          labelLayout: {
            // hideOverlap: true,
            // moveOverlap: 'shiftY',
            draggable: true
          }
        }
      ]
    })
  }

  if (!option && details?.labels?.length > 0) return <></>;

  return (
    <>
    {
      details?.labels?.length > 0 ? 
        <ReactECharts
            option={option}
            style={{ height: 200 }}
            // style={{ height: 300 }}
            onEvents={{
              // 'click': onChartClick,
              // 'legendselectchanged': onChartLegendselectchanged
            }}
            />
      : <NoDataChart titleChart={titleChart} titleChartNoData={titleChartNoData} typeIcon={typeIcon} />
    }
    </>
  );
});